module.exports = __webpack_public_path__ + "img/geofisica_4-3.adfdb036.webp";